exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer---1MePj {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  position: fixed;\n  height: 50px;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  padding-left: 10px;\n  background-color: #adb6bc; }\n  .footer---1MePj .backPanel---2cMzr {\n    width: 10%; }\n  .footer---1MePj .savePanel---3AvMa {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    width: 90%; }\n  .footer---1MePj .savePanel---3AvMa > div {\n      margin-left: 10px; }\n", ""]);

// exports
exports.locals = {
	"footer": "footer---1MePj",
	"backPanel": "backPanel---2cMzr",
	"savePanel": "savePanel---3AvMa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/course-creator/footer/index.scss
// module id = 756
// module chunks = 3